export { DrillFooterMeaningView } from "#drill-footer-meaning-view";
